import { AppBar as MuiAppBar, LinearProgress as MuiLinearProgress, Toolbar } from '@material-ui/core';
import toArray from 'lodash/toArray';
import { minHeight, space, position as styledPosition } from 'styled-system';
import { Box } from '~ui-kit/components/box/box';
import { css, styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';

function getNavbarHeight(hasSecondaryToolbar: boolean, dynamicHeight: boolean, forceFullHeight: boolean): string {
  if (dynamicHeight && !forceFullHeight) {
    return 'auto';
  }

  let value: number = theme.navbar.primaryToolbarHeight;
  if (forceFullHeight || hasSecondaryToolbar) {
    value += theme.navbar.secondaryToolbarHeight;
  }

  return value + 'px';
}

export const BaseNavbarContainer = styled(Box)<{
  $hasSecondaryToolbar: boolean;
  $isSticky: boolean | boolean[];
  $forceFullHeight: boolean;
}>`
  ${(props) => {
    return space({
      mb: toArray(props.$isSticky).map((isSticky) => {
        if (isSticky) {
          return getNavbarHeight(props.$hasSecondaryToolbar, false, props.$forceFullHeight);
        }
        return 0;
      }),
    });
  }}
`;

export const AppBar = styled(MuiAppBar).attrs({
  elevation: 2,
  color: 'inherit',
})<{
  $dynamicHeight: boolean;
  $isSticky: boolean | boolean[];
  $hasSecondaryToolbar: boolean;
  $forceFullHeight: boolean;
}>`
  height: ${(props) => getNavbarHeight(props.$hasSecondaryToolbar, props.$dynamicHeight, props.$forceFullHeight)};
  justify-content: center;
  ${(props) =>
    styledPosition({
      position: toArray(props.$isSticky).map((isSticky) => (isSticky ? 'fixed !important' : 'relative !important')),
    })};
`;

export const MainToolBar = styled(Toolbar)<{ $hasSecondaryToolbar?: boolean }>`
  &.MuiToolbar-root {
    ${(props) => minHeight({ minHeight: [`${props.theme.navbar.primaryToolbarHeight}px`] })}
    ${(props) =>
      props.$hasSecondaryToolbar &&
      css`
        padding-top: ${props.theme.navbar.secondaryToolbarHeight}px;
      `}
  }
`;

export const SecondToolBar = styled(Toolbar)`
  &.MuiToolbar-root {
    align-items: end;
    justify-content: center;

    ${(props) => minHeight({ minHeight: props.theme.navbar.secondaryToolbarHeight + 'px' })}
  }
`;

export const Spacer = styled.div`
  flex-grow: 1;
`;

export const LinearProgress = styled(MuiLinearProgress).attrs(() => ({
  color: 'secondary',
  variant: 'determinate',
}))<{ height: string }>`
  &.MuiLinearProgress-root {
    height: ${(props) => props.height};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  & .MuiLinearProgress-barColorSecondary {
    background-color: ${(props) => props.theme.colors.primary};
    height: ${(props) => props.height};
  }
`;
